export default __webpack_public_path__ + "static/media/medal-4.e979fca1.svg";